var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './MonitorModal.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { EditMonitorFooter } from '@security/monitors/monitor-form/EditMonitorFooter';
import { isEqual } from 'lodash';
import { SonarModal } from '@ui/modals';
import { SonarText } from '@ui/text';
import { useForm } from '@hooks';
import { defaultConfig } from './monitor-form/MonitorMenu';
import { MonitorForm } from './monitor-form/MonitorForm';
import React, { useCallback, useEffect, useRef, useState } from 'react';
export const CreateMonitorModal = (_a) => {
    var _b, _c;
    var { defaultMonitor, menuOptions, monitor, onCancel, onChange, onSave, title } = _a, rest = __rest(_a, ["defaultMonitor", "menuOptions", "monitor", "onCancel", "onChange", "onSave", "title"]);
    const { form } = useForm({
        required: ['monitorConfig.monitorTypeId']
    });
    const ref = useRef(null);
    const [currentMonitor, setCurrentMonitor] = useState(monitor);
    const [isValid, setIsValid] = useState((_c = (_b = ref.current) === null || _b === void 0 ? void 0 : _b.isValid()) !== null && _c !== void 0 ? _c : false);
    useEffect(() => {
        var _a, _b;
        if (!isEqual(monitor, currentMonitor)) {
            setCurrentMonitor(monitor);
            form.setFieldsValue(monitor !== null && monitor !== void 0 ? monitor : defaultConfig);
            setIsValid((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.isValid()) !== null && _b !== void 0 ? _b : Boolean(monitor === null || monitor === void 0 ? void 0 : monitor.templateId));
        }
    }, [currentMonitor, form, monitor, ref]);
    const handleClose = useCallback(() => {
        setCurrentMonitor(undefined);
        form.setFieldsValue(defaultConfig);
    }, [form]);
    const handleSave = useCallback((overwrite) => {
        var _a, _b, _c;
        if (overwrite !== undefined) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.saveTemplate(overwrite);
        }
        else if (currentMonitor === null || currentMonitor === void 0 ? void 0 : currentMonitor.templateId) {
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.saveTemplate(false);
        }
        else {
            (_c = ref.current) === null || _c === void 0 ? void 0 : _c.save();
        }
        onSave();
    }, [currentMonitor, onSave, ref]);
    const handleOnChange = useCallback((newMonitor) => {
        var _a, _b;
        if (newMonitor && !isEqual(newMonitor, currentMonitor)) {
            setCurrentMonitor(newMonitor);
            if (onChange) {
                onChange(newMonitor);
            }
        }
        setIsValid((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.isValid()) !== null && _b !== void 0 ? _b : false);
    }, [currentMonitor, onChange, setCurrentMonitor]);
    return (React.createElement(SonarModal, Object.assign({ afterClose: handleClose, centered: true, className: 'monitor-modal flex-inputs', destroyOnClose: true, footer: React.createElement(EditMonitorFooter, { disableSave: !isValid, monitor: currentMonitor, onCancel: onCancel, onSave: handleSave }), maskClosable: false, onCancel: onCancel, title: React.createElement(SonarText, { className: classNames('h3', 'monitor-modal-header') }, title !== null && title !== void 0 ? title : COPY_SPECIFIC.CREATE_NEW_MONITOR) }, rest),
        React.createElement(MonitorForm, { defaultMonitor: defaultMonitor, form: form, menuOptions: menuOptions, monitor: currentMonitor, onChange: handleOnChange, ref: ref, showRecommendedActionTemplates: true })));
};
